// Types
type IconProps = {
  size?: number;
  className?: string;
};

/**
 * Microsoft Teams icon
 */
export const TeamsIcon = ({ size = 26, className }: IconProps) => (
  <svg
    width={size}
    height={(size * 24) / 26}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#teams_clip0)">
      <path
        d="M17.575 8.78906H24.0831C24.698 8.78906 25.1964 9.2875 25.1964 9.90236V15.8304C25.1964 18.0901 23.3645 19.922 21.1048 19.922H21.0854C18.8256 19.9223 16.9935 18.0907 16.9932 15.831C16.9932 15.8308 16.9932 15.8306 16.9932 15.8304V9.37091C16.9932 9.04956 17.2537 8.78906 17.575 8.78906Z"
        fill="#5059C9"
      />
      <path
        d="M21.9737 7.61726C23.4299 7.61726 24.6104 6.43675 24.6104 4.98051C24.6104 3.52427 23.4299 2.34375 21.9737 2.34375C20.5174 2.34375 19.3369 3.52427 19.3369 4.98051C19.3369 6.43675 20.5174 7.61726 21.9737 7.61726Z"
        fill="#5059C9"
      />
      <path
        d="M13.7706 7.61731C15.874 7.61731 17.5792 5.91211 17.5792 3.80865C17.5792 1.70519 15.874 0 13.7706 0C11.6671 0 9.96191 1.70519 9.96191 3.80865C9.96191 5.91211 11.6671 7.61731 13.7706 7.61731Z"
        fill="#7B83EB"
      />
      <path
        d="M18.8489 8.78906H8.10613C7.4986 8.8041 7.018 9.30829 7.0321 9.91584V16.6771C6.94726 20.323 9.83172 23.3485 13.4775 23.4377C17.1233 23.3485 20.0077 20.323 19.9229 16.6771V9.91584C19.937 9.30829 19.4564 8.8041 18.8489 8.78906Z"
        fill="#7B83EB"
      />
      <path
        opacity="0.1"
        d="M14.0629 8.78906V18.2638C14.06 18.6983 13.7967 19.0886 13.3949 19.2541C13.267 19.3082 13.1295 19.3361 12.9906 19.3361H7.54719C7.47102 19.1427 7.40071 18.9494 7.34211 18.7501C7.137 18.0778 7.03234 17.3788 7.03155 16.6759V9.91408C7.01747 9.30749 7.49727 8.8041 8.10383 8.78906H14.0629Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M13.477 8.78906V18.8498C13.477 18.9887 13.4491 19.1261 13.3949 19.2541C13.2295 19.6558 12.8392 19.9191 12.4047 19.922H7.82259C7.72298 19.7287 7.62923 19.5353 7.54719 19.3361C7.46516 19.1369 7.40071 18.9494 7.34211 18.7501C7.137 18.0778 7.03234 17.3788 7.03155 16.6759V9.91408C7.01747 9.30749 7.49727 8.8041 8.10383 8.78906H13.477Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M13.477 8.78906V17.6779C13.4725 18.2682 12.995 18.7457 12.4047 18.7501H7.34211C7.137 18.0778 7.03234 17.3788 7.03155 16.6759V9.91408C7.01747 9.30749 7.49727 8.8041 8.10383 8.78906H13.477Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.891 8.78906V17.6779C12.8865 18.2682 12.4091 18.7457 11.8187 18.7501H7.34211C7.137 18.0778 7.03234 17.3788 7.03155 16.6759V9.91408C7.01747 9.30749 7.49727 8.8041 8.10383 8.78906H12.891Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M14.0626 5.75977V7.6055C13.963 7.61136 13.8692 7.61722 13.7696 7.61722C13.67 7.61722 13.5762 7.61137 13.4766 7.6055C13.2788 7.59238 13.0827 7.56099 12.8907 7.51175C11.7041 7.23076 10.7238 6.39862 10.2539 5.27344C10.1731 5.08449 10.1103 4.88829 10.0664 4.6875H12.9903C13.5816 4.68974 14.0603 5.16849 14.0626 5.75977Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M13.4776 6.34571V7.6055C13.2798 7.59237 13.0836 7.56099 12.8916 7.51175C11.7051 7.23075 10.7248 6.39861 10.2549 5.27344H12.4053C12.9966 5.27568 13.4753 5.75444 13.4776 6.34571Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M13.4776 6.34571V7.6055C13.2798 7.59237 13.0836 7.56099 12.8916 7.51175C11.7051 7.23075 10.7248 6.39861 10.2549 5.27344H12.4053C12.9966 5.27568 13.4753 5.75444 13.4776 6.34571Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.8916 6.34572V7.51175C11.7051 7.23075 10.7248 6.39861 10.2549 5.27344H11.8194C12.4106 5.27569 12.8894 5.75445 12.8916 6.34572Z"
        fill="black"
      />
      <path
        d="M1.07403 5.27344H11.8168C12.4099 5.27344 12.8908 5.75431 12.8908 6.34747V17.0902C12.8908 17.6834 12.4099 18.1642 11.8168 18.1642H1.07403C0.480856 18.1642 0 17.6834 0 17.0902V6.34747C0 5.75431 0.480868 5.27344 1.07403 5.27344Z"
        fill="url(#teams_paint0)"
      />
      <path
        d="M9.27235 9.36193H7.12485V15.2097H5.75667V9.36193H3.61914V8.22754H9.27235V9.36193Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="teams_paint0"
        x1="2.2394"
        y1="4.4342"
        x2="10.6514"
        y2="19.0035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A62C3" />
        <stop offset="0.5" stopColor="#4D55BD" />
        <stop offset="1" stopColor="#3940AB" />
      </linearGradient>
      <clipPath id="teams_clip0">
        <rect width="25.1957" height="23.4378" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
